import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  FETCH_REFERAL_INFO
} from "./actionTypes"
import {
  fetchReferalInfoSuccess
} from "./actions";

import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { ADMIN_MS_EXT } from "../../helpers/url_helper";

function* fetchReferalInfo(data) {
  try {
    const response = yield call(
      makeAjax,
      url.ADMIN_API.showTenantPageData,
      data.payload,
      ADMIN_MS_EXT
    );
    if (response.status == 'SUCCESS') {
      yield all([
        put(fetchReferalInfoSuccess({ response: response.data }))
      ]);
    }
    else {
      showMessage(response);
    }
  } catch (error) {
    showMessage(error);
    
    // alert
  }
}

function* referalInfomationSaga() {
  yield takeEvery(FETCH_REFERAL_INFO, fetchReferalInfo);
}

export default referalInfomationSaga;
